import { HashRouter, Routes, Route } from "react-router-dom";
import AccountDetails from "../pages/General/AccountDetails";
import PasswordRecovery from "../pages/General/PasswordRecovery";
import Register from "../pages/General/Register";
import Terms from "../pages/General/Terms";
import AddAgency from "../pages/Comercial/Agencies/AddAgency";
import Agencies from "../pages/Comercial/Agencies/Agencies";
import AgencyDetails from "../pages/Comercial/Agencies/AgencyDetails";
import EditAgency from "../pages/Comercial/Agencies/EditAgency";
import AddExcursion from "../pages/Comercial/Excursions/AddExcursion";
import EditExcursion from "../pages/Comercial/Excursions/EditExcursion";
import ExcursionDetails from "../pages/Comercial/Excursions/ExcursionDetails";
import Excursions from "../pages/Comercial/Excursions/Excursions";
import Home from "../pages/General/Home";
import Login from "../pages/General/Login";
import TurismLandingPage from "../pages/General/LandingPage";
import ExcursionPage from "../pages/Client/ExcursionPage";
import TourismSearchPage from "../pages/Client/SearchPage";
import TourismStorePage from "../pages/Client/TurismStorePage";
import ManagerStoresProvider from "../context/ManagerStores/provider";
import Checkout from "@/pages/Client/Checkout";
import ExcursionsHistory from "@/pages/Client/ExcursionsHistory";
import ProtectedComponent from "@/components/general/ProtectedComponent";
import Dashboard from "@/pages/Comercial/Dashboard";



const AppRoutes = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<TurismLandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/password-recovery" element={<PasswordRecovery />} />
        <Route path="/terms" element={<Terms />} />

        <Route path="" element={<ProtectedComponent />}>
          <Route path="/home" element={<Home />} />
          <Route path="/user/details" element={<AccountDetails />} />
          <Route
            path="/agencies"
            element={
              <ManagerStoresProvider>
                <Agencies />
              </ManagerStoresProvider>
            }
          />
          <Route
            path="/agencies/add"
            element={
              <ManagerStoresProvider>
                <AddAgency />
              </ManagerStoresProvider>
            }
          />
          <Route
            path="/agencies/edit"
            element={
              <ManagerStoresProvider>
                <EditAgency />
              </ManagerStoresProvider>
            }
          />
          <Route
            path="/agencies/details"
            element={
              <ManagerStoresProvider>
                <AgencyDetails />
              </ManagerStoresProvider>
            }
          />
          <Route
            path="/excursions"
            element={
              <ManagerStoresProvider>
                <Excursions />
              </ManagerStoresProvider>
            }
          />
          <Route
            path="/excursions/add"
            element={
              <ManagerStoresProvider>
                <AddExcursion />
              </ManagerStoresProvider>
            }
          />
          <Route
            path="/excursions/edit"
            element={
              <ManagerStoresProvider>
                <EditExcursion />
              </ManagerStoresProvider>
            }
          />
          <Route
            path="/excursions/details"
            element={
              <ManagerStoresProvider>
                <ExcursionDetails />
              </ManagerStoresProvider>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ManagerStoresProvider>
                <Dashboard />
              </ManagerStoresProvider>
            }
          />
          <Route path="/search" element={<TourismSearchPage />} />

          <Route path="/checkout" element={<Checkout />} />
          <Route path="/history" element={<ExcursionsHistory />} />
          <Route path="/store" element={<TourismStorePage />} />
          <Route path="/excursion" element={<ExcursionPage />} />
        </Route>
      </Routes>
    </HashRouter>
  );
};

export default AppRoutes;
